import { createInertiaApp } from "@inertiajs/svelte";
import { app, authentication } from "@microsoft/teams-js";
import jwtDecode, { type JwtPayload } from "jwt-decode";
import { get } from "svelte/store";
import { data, modelGateway, requests, setupData, setupSharedProps, sharedProps } from "./services";
import axios from "axios";
import { router } from '@inertiajs/svelte';
import "vite/modulepreload-polyfill";
import { inertia } from "../node_modules/@inertiajs/svelte/dist/index";
import "../styling/main.css";

const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
axios.defaults.headers.post['X-CSRF-TOKEN'] = csrfToken;

createInertiaApp( {
    resolve: name => {
        const pages = import.meta.glob( './pages/**/*.svelte', { eager: true } );
        return pages[ `./pages/${name}.svelte` ] as any;
    },
    setup( { el, App, props } ) {
        new App( { target: el } );
    },
} );

init();

function init() {


    app.initialize().then( async () => {

        const context = app.getContext().then( context => {
            let lang:string = '';
            switch (context.app.locale) {
                case 'de-de':
                    lang = 'de';
                    break;
                case 'de-ch':
                    lang = 'de';
                    break;
                case 'fr-fr':
                    lang = 'fr';
                    break;
                case 'it-it':
                    lang = 'it';
                    break;
                default:
                    lang = 'de';
            }
            setLang(lang);
        });

        // inject bearer token
        authentication.getAuthToken().then( token => {
        } );

    } ).catch( e => {
        console.log( 'Error initialising teams' );
        console.log(e)
        setupSharedProps();

        let lang = 'de';
        setLang(sharedProps.currentLocale);
    } );

}

function parseJWT(token:string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function setLang(lang:string) {
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/').filter(Boolean);

    const currentLocale = ['de', 'fr', 'it'].includes(pathParts[0]) ? pathParts[0] : null;

    if (currentLocale !== lang) {
        const remainingPath = pathParts.slice(currentLocale ? 1 : 0).join('/');
        const newUrl = `/${lang}${remainingPath ? '/' + remainingPath : ''}`;
        window.location.replace(newUrl);
    }
}

